import { PageRef } from 'providers/page-ref';

export type HelpCardPageParams = {
  helpId?: string;
  returnCallback?: string;
  local?: {
    returnContext?: unknown;
  };
};

export const IHelpCardPage: PageRef<HelpCardPageParams, void> = {
  pageName: 'HelpCardPage',
} as PageRef<HelpCardPageParams, void>;
